export const toDate = (d: any): Date => {
  if (!d) return new Date(NaN);
  if (d instanceof Date) return d;
  if (typeof d === "string" || typeof d === "number") return new Date(d);
  if (typeof d.toDate === "function") return d.toDate();
  if (d._d instanceof Date) return d._d;
  return new Date(d);
};

export const formatDate = (d: any): string => {
  try {
    return toDate(d).toLocaleDateString();
  } catch {
    return "";
  }
};
